export const updateValue = (event, setter, maxValue, minValue = 0) => {
  event.preventDefault();
  const { value } = event.target;

  if (value === '') {
    setter('');
    return;
  }

  const regex = /^[0-9]*$/;

  if (Number.isNaN(Number(value)) || !regex.test(value)) {
    return;
  }

  let newValue = Number(value);

  let maxValueValid = maxValue !== undefined && newValue <= maxValue;
  let minValueValid = minValue !== undefined && newValue >= minValue;

  if (maxValueValid && minValueValid) {
    setter(value);
  }
};
